import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button, Card, CardHeader, CardBody } from 'reactstrap';
import { getProjects } from '../../actions/projectAction';
import ProjectCreateModal from './ProjectCreateModal';
import ProjectEditModal from './ProjectEditModal';
import ProjectView from './ProjectView';

class ProjectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreateModal: false,
      showEditModal: false,
      showViewModal: false,
      selectedProject: null
    };
  }

  componentDidMount() {
    this.props.getProjects();
  }

  handleCreate = () => {
    this.setState({ showCreateModal: true });
  }

  handleEdit = (project) => {
    this.setState({ 
      showEditModal: true,
      selectedProject: project
    });
  }

  handleView = (project) => {
    this.setState({ 
      showViewModal: true,
      selectedProject: project
    });
  }

  render() {
    const { projects } = this.props;
    const { showCreateModal, showEditModal, showViewModal, selectedProject } = this.state;

    return (
      <div className="content">
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="title">Projects</h4>
              <Button color="primary" onClick={this.handleCreate}>
                Create New Project
              </Button>
            </div>
            <div className="text-muted mb-3">
              {projects.length === 0
                ? 'No projects found'
                : `Found ${projects.length} ${projects.length === 1 ? 'project' : 'projects'}`}
            </div>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {projects.map(project => (
                  <tr key={project._id}>
                    <td>{project.title}</td>
                    <td>{project.description}</td>
                    <td>{new Date(project.createdAt).toLocaleString()}</td>
                    <td>
                      <Button 
                        color="info" 
                        size="sm" 
                        className="mr-2"
                        onClick={() => this.handleView(project)}
                      >
                        View
                      </Button>
                      <Button 
                        color="warning" 
                        size="sm"
                        onClick={() => this.handleEdit(project)}
                      >
                        Edit
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>

        <ProjectCreateModal 
          isOpen={showCreateModal}
          toggle={() => this.setState({ showCreateModal: false })}
        />

        {selectedProject && (
          <>
            <ProjectEditModal
              isOpen={showEditModal}
              toggle={() => this.setState({ showEditModal: false })}
              project={selectedProject}
            />
            <ProjectView
              isOpen={showViewModal}
              toggle={() => this.setState({ showViewModal: false })}
              project={selectedProject}
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.projectReducer.projects
});

export default connect(mapStateToProps, { getProjects })(ProjectList); 